module.exports = __webpack_public_path__ + "static/115_001-71bb5882bcaf5fc1dc8dfbc7e559538a.jpg";